import { Search } from './Search';
import { Watchlist } from './Watchlist';
import { Download } from './Download';
import { ToggleFilters } from './ToggleFilters';
import { ClearFilters } from './ClearFilters';

export enum HeaderComponent {
    SEARCH = 'SEARCH',
    WATCHLIST = 'WATCHLIST',
    DOWNLOAD = 'DOWNLOAD',
    TOGGLE_FILTERS = 'TOGGLE_FILTERS',
    CLEAR_FILTERS = 'CLEAR_FILTERS',
}

/**
 * @title Header Element
 */
export type HeaderElement =
    | Search
    | Watchlist
    | Download
    | ToggleFilters
    | ClearFilters;



// WEBPACK FOOTER //
// ./src/models/configuration/header/HeaderLayout.ts